export enum AppMode 
{
    Arrivals,
    Departures
}